/**
 * Created by Christof Sander on 22.06.2016.
 *
 * this module collects all constants needed
 *
 * INFO: never use zero as value so isEmpty function can be used within the code
 */

module.exports = Object.freeze({
	ERROR: {
		LEVEL: {
			LOG:        1,
			WARNING:    2,
			ERROR:      3,
			CRITICIAL:  4
		},
		HANDLING_TYPE: {
			DEFAULT:                        1,
			NOT_HANDLED_LOCAL:              2,
			DURING_GLOBAL_ERROR_HANDLING:   3,
			DURING_LOCAL_ERROR_HANDLING:    4
		}
	},
	COMPONENT: {
		ACTION: {
			TYPE: {
				OPEN:               1,
				LOAD:               2,
				TAB:                3,
				INCLUDE:            4,
				LOAD_RESOURCE:      5,
				SUBMIT_RESOURCE:    6
			},
			TARGET: {
				ELEMENT: {
					SELECTOR:           1,
					SUB_SELECTOR:       2,
					SELF:               3,
					PARENT_COMPONENT:   4
				},
				POSITION: {
					HTML:       1,
					REPLACE:    2,
					BEFORE:     3,
					AFTER:      4,
					APPEND:     5,
					PREPEND:    6,
					ATTACH:     7,
					MODAL:      8
				},
				MODE: {
					INVALID:    1,
					JQUERY:     2,
					COMPONENT:  3
				}
			}
		}
	},

	TEMPLATE: {
		ATOM: {
			STRING:     1,
			HTML:       2,
			JSON:       3,
			INT:        4,
			BOOLEAN:    5,
			LIST:       6,
			TEMPLATE:   7,
			URL:        8,
			FORM_FIELD: 9
		}
	}
});